<div class="card">
    <div class="mb-6">
      <app-nextRaceDay-widget></app-nextRaceDay-widget>
    </div>
    @if (calendarSeasonId) {
    <div class="mb-2">
        <app-raceDaysOverview-widget [season_id]="calendarSeasonId" [seasonName]="calendarSeasonName" [plan]="calendarPlan" [color_season]="true"></app-raceDaysOverview-widget>
    </div>
    }

    <div class="font-semibold text-l mb-6 flex justify-center">
        <a href="https://discord.gg/4vuuSMyTuT" target="_blank" rel="noopener noreferrer" class="inline-block shadow-2xl rounded-lg overflow-hidden text-center bg-white/90 dark:bg-gray-800/90 cursor-pointer no-underline px-6 py-3 text-orange-500 transition-all duration-300 hover:scale-105 hover:shadow-orange-500/30" style="font-family: 'CarterOne', sans-serif;">
            <i class="pi pi-discord mr-2"></i>Fahre mit uns<i class="pi pi-arrow-right ml-3"></i>
        </a>
    </div>

    <div class="mb-2">
        <app-leagueOverview-widget></app-leagueOverview-widget>
    </div>
    <div class="font-semibold text-l mb-6 flex justify-center">
        <a routerLink="/pages/ruleset" class="inline-block shadow-2xl rounded-lg overflow-hidden text-center bg-white/90 dark:bg-gray-800/90 cursor-pointer no-underline px-6 py-3 text-orange-500 transition-all duration-300 hover:scale-105 hover:shadow-orange-500/30" style="font-family: 'CarterOne', sans-serif;">
            <i class="pi pi-book mr-2"></i>Unser Regelwerk<i class="pi pi-arrow-right ml-3"></i>
        </a>
    </div>

    @if (activeSeasonId) {
    <div class="mb-2">
        <app-leagueTableOverview-widget [season_id]="activeSeasonId" [seasonName]="activeSeasonName"></app-leagueTableOverview-widget>
    </div>
 
    <div class="font-semibold text-l mb-6 flex justify-center">
        <a [routerLink]="['/season', currentSeasonId]" class="inline-block shadow-2xl rounded-lg overflow-hidden text-center bg-white/90 dark:bg-gray-800/90 cursor-pointer no-underline px-6 py-3 text-orange-500 transition-all duration-300 hover:scale-105 hover:shadow-orange-500/30" style="font-family: 'CarterOne', sans-serif;">
            <i class="pi pi-car mr-2"></i>Details {{ currentSeasonName || 'Season ' + currentSeasonId }}<i class="pi pi-arrow-right ml-3"></i>
        </a>
    </div>
    }

</div>
